'use strict';

var chunkMS6X5XQ5_js = require('../chunk-MS6X5XQ5.js');
require('../chunk-FGATKSXZ.js');
require('../chunk-ERLKLNQZ.js');
require('../chunk-JHFKSNYO.js');
require('../chunk-JOML6I2W.js');



Object.defineProperty(exports, 'formatDateTime', {
	enumerable: true,
	get: function () { return chunkMS6X5XQ5_js.a; }
});
